export default "__VITE_ASSET__DJNjeKQu__"